import { useState } from 'react';
import { Sidebar } from './Sidebar';
import ppiLogo from '../images/ppiweb_logo.png';
import './Layout.css';

export function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="layout">
      {/* Site header with PPI branding - matches ppiweb.io */}
      <header className="site-header">
        <div className="site-header__container">
          <a href="https://ppiweb.io" className="site-header__logo-link" target="_blank" rel="noopener noreferrer">
            <img src={ppiLogo} alt="PPI Global" className="site-header__logo" />
          </a>
          <nav className="site-header__nav">
            <a href="https://ppiweb.io/ppi_home" target="_blank" rel="noopener noreferrer">Home</a>

            <div className="site-header__dropdown">
              <a href="https://ppiweb.io/about_ppi" target="_blank" rel="noopener noreferrer">About</a>
              <div className="site-header__dropdown-menu">
                <a href="https://ppiweb.io/ppi_manifesto" target="_blank" rel="noopener noreferrer">Our Manifesto</a>
                <a href="https://www.youtube.com/watch?v=7Jotm_imuIY&t=333s" target="_blank" rel="noopener noreferrer">PPI Documentary</a>
                <a href="https://ppiweb.io/our_team" target="_blank" rel="noopener noreferrer">Our Team</a>
                <a href="https://ppiweb.io/ppi_videos" target="_blank" rel="noopener noreferrer">Testimonials</a>
              </div>
            </div>

            <div className="site-header__dropdown">
              <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Industries</a>
              <div className="site-header__dropdown-menu">
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Electrical</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Nuclear Generation</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Shipping/Transportation</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Energy/Petrochemical</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Manufacturing</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Medical</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Law Enforcement</a>
                <a href="https://ppiweb.io/industries_served" target="_blank" rel="noopener noreferrer">Small Business</a>
              </div>
            </div>

            <div className="site-header__dropdown">
              <a href="https://ppiweb.io/diy_dwy_dfy" target="_blank" rel="noopener noreferrer">Services</a>
              <div className="site-header__dropdown-menu">
                <a href="https://ppiweb.io/integration_transformation" target="_blank" rel="noopener noreferrer">Integration/Transform Culture</a>
                <a href="https://ppiweb.io/safety_human_performance" target="_blank" rel="noopener noreferrer">Safety & Human Performance</a>
                <a href="https://ppiweb.io/diy_dwy_dfy" target="_blank" rel="noopener noreferrer">HPI/HOP Training & Development</a>
                <a href="https://ppiweb.io/leadership_coaching_mentoring" target="_blank" rel="noopener noreferrer">Principle-Based LEADERSHIP&trade;</a>
                <a href="https://ppiweb.io/diy_dwy_dfy" target="_blank" rel="noopener noreferrer">Courses & Certifications</a>
                <a href="https://ppiweb.io/error_reduction_tools" target="_blank" rel="noopener noreferrer">Human Performance Tools</a>
                <a href="https://ppiweb.io/human_performance_barometer_home" target="_blank" rel="noopener noreferrer">Measuring Human Performance</a>
                <a href="https://ppiweb.io/culture_assessment" target="_blank" rel="noopener noreferrer">Assessing Your Work Culture</a>
              </div>
            </div>

            <div className="site-header__dropdown">
              <a href="https://ppiweb.io/infographics_downloads" target="_blank" rel="noopener noreferrer">Resources</a>
              <div className="site-header__dropdown-menu">
                <a href="https://ppiweb.io/7_natural_principles_home" target="_blank" rel="noopener noreferrer">The 7 Natural Principles</a>
                <a href="https://ppiweb.io/ppilab" target="_blank" rel="noopener noreferrer">PPI Lab</a>
                <a href="https://ppiweb.io/infographics_downloads" target="_blank" rel="noopener noreferrer">Infographics & Downloads</a>
                <a href="https://ppiweb.io/take_2_with_tim" target="_blank" rel="noopener noreferrer">Take Two With Tim</a>
                <a href="https://bit.ly/ppi-podcast" target="_blank" rel="noopener noreferrer">PRINCIPLES Podcast</a>
                <a href="https://youtube.com/ppiweb" target="_blank" rel="noopener noreferrer">PPI YouTube Channel</a>
                <a href="https://ppiweb.io/special_reports_case_studies" target="_blank" rel="noopener noreferrer">Special Reports & Case Studies</a>
              </div>
            </div>

            <a href="https://ppiweb.io/ppi_contact_us" target="_blank" rel="noopener noreferrer">Contact</a>
          </nav>
          <a href="https://api.leadconnectorhq.com/widget/bookings/bobcat" className="site-header__cta" target="_blank" rel="noopener noreferrer">
            Schedule a Call
          </a>
        </div>
      </header>

      {/* Mobile header */}
      <header className="mobile-header">
        <button
          className="mobile-header__menu"
          onClick={() => setSidebarOpen(true)}
          aria-label="Open menu"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
          </svg>
        </button>
        <span className="mobile-header__title">TIM'S BLOG</span>
      </header>

      <div className="layout__container">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <main className="main">
          {children}
        </main>
      </div>

      {/* Site footer - matches ppiweb.io */}
      <footer className="site-footer">
        <div className="site-footer__container">
          <div className="site-footer__brand">
            <a href="https://ppiweb.io" target="_blank" rel="noopener noreferrer">
              <img src={ppiLogo} alt="PPI Global" className="site-footer__logo" />
            </a>
            <p className="site-footer__tagline">Principle-Based Performance Excellence</p>
          </div>

          <div className="site-footer__links">
            <div className="site-footer__column">
              <h4>About PPI</h4>
              <a href="https://ppiweb.io/ppi_manifesto" target="_blank" rel="noopener noreferrer">Our Manifesto</a>
              <a href="https://ppiweb.io/our_team" target="_blank" rel="noopener noreferrer">Our Team</a>
              <a href="https://www.youtube.com/watch?v=7Jotm_imuIY&t=333s" target="_blank" rel="noopener noreferrer">PPI Documentary</a>
            </div>

            <div className="site-footer__column">
              <h4>Resources</h4>
              <a href="https://ppiweb.io/infographics_downloads" target="_blank" rel="noopener noreferrer">Downloads</a>
              <a href="https://www.youtube.com/@ppiweb" target="_blank" rel="noopener noreferrer">YouTube Channel</a>
            </div>

            <div className="site-footer__column">
              <h4>Connect</h4>
              <a href="https://ppiweb.io/ppi_contact_us" target="_blank" rel="noopener noreferrer">Contact Us</a>
              <a href="https://api.leadconnectorhq.com/widget/bookings/bobcat" target="_blank" rel="noopener noreferrer">Schedule a Call</a>
            </div>
          </div>

          <div className="site-footer__social">
            <a href="https://www.linkedin.com/company/ppi-global" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="https://www.youtube.com/@ppiweb" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
            <a href="https://twitter.com/ppiweb" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="site-footer__bottom">
          <p>© {new Date().getFullYear()} PPI Global, Ltd. All rights reserved.</p>
          <div className="site-footer__legal">
            <a href="https://ppiweb.io/privacy_policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            <a href="https://ppiweb.io/terms_and_conditions" target="_blank" rel="noopener noreferrer">Terms of Use</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
